exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-gray[data-v-4e1a726f] {\r\n  font-size: 15px;\n}\n.W-Box[data-v-4e1a726f] {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n  -webkit-flex-wrap: wrap;\r\n          flex-wrap: wrap;\n}\r\n/* .W-BoxContent {\r\n  width: 50%;\r\n} */\r\n", ""]);

// exports
